export default {
  init() {
    // JavaScript to be fired on the savings page
    // set up hover overs
    /*
    $(document).tooltip({
      position: {
        my: 'center bottom',
        at: 'center top',
      },
      tooltipClass: 'top',
    });
    */

    // buttons
    $('#butPrint').click(function() {
      window.print();
    });

    // Checks if NM user //
    /*
    $.ajax({
      url: '/rrtpbillcompare/Servlet?type=is-netmeter&account=' + $('#account').val(),
      success: function(data) {
        //console.log('is-netmeter');
       if (data == 'rider1'|| data == 'rider19') {
          //console.log('data is true');
          $('.net-meter-off').hide();
          $('.net-meter-on').show();
        } else {
          // do nothing
        }
      },
      cache: false,
      async: false,
    });
    */

    // make global, since webpack uses enclosures to scope partials
    window.mhpa = window.mhpa || {};
    window.mhpa.loadAccountData = function() {
      
      $.get('/rrtpbillcompare/Servlet?type=has-base-data&account=' + $('#account').val(), function(data) {
        if (data.indexOf('net-metered') >= 0) {
          $.fancybox({
            href: '#net-metered',
          });
        } else {
          $('.main-wrap').show();
        }
      });
      $('#report-my-savings').attr('href', '/rrtpbillcompare/Servlet?type=report-my-savings&account=' + $('#account').val());

      // Checks if NM user //
      $.ajax({
        url: '/rrtpbillcompare/Servlet?type=is-netmeter&account=' + $('#account').val(),
        success: function(data) {
         if (data == 'rider1') {
            $('.net-meter-off').hide();
            $('.net-meter-on').show();
            $('#report-my-savings-nm').attr('href', '/rrtpbillcompare/Servlet?type=report-my-savings-nm&account=' + $('#account').val());
            $.getJSON('/rrtpbillcompare/Servlet?type=bill-table-rider-1&account=' + $('#account').val(), function(data) {
              $('#bill-table thead').remove();
              $('#bill-table tbody tr').remove();
              $('#bill-table tbody').remove();
              $('#bill-table').trigger('destroy');
              $('#bill-table').append(
                 `<thead>
                      <tr role="row" class="tablesorter-headerRow">
                        <th id="start-date" title="This date indicates the end of your billing period.">End of Billing Period</th>
                        <th id="usage" title="kWh from the electric system.">kWh From Grid</th>
                        <th id="usage" title="kWh supplied to the electric system.">kWh To Grid</th>
                        <th id="days-in-period" title="Your grid consumption after subtracting your generated kWh during this billing period.">Net Grid Consumption (kWh)</th>
                        <th id="total-cost-rrtp" title="This is the total cost of your electricity on Hourly Pricing.">Total Cost With Hourly Pricing*</th>
                        <th id="total-cost-std" title="This would be the total cost of your electricity if you were on ComEd standard fixed-price rate.">Total Cost With ComEd Standard Rate**</th>
                        <th id="savings-rrtp" title="This is the difference between the cost on Hourly Pricing vs. ComEd standard fixed price-rate. Savings are indicated by a positive number.">Savings With Hourly Pricing</th>
                        <th id="drill-down" title="Click the link below to see the billing details for each corresponding billing period.">See Billing Details</th>
                      </tr>
                    </thead>`
              )
              data.forEach(el => {
                const fromKwh = $("<div>").text(el.fromKwh).text();
                const toKwh = $("<div>").text(el.toKwh).text();
                const totalCostWithHPInt = $("<div>").text(el.totalCostWithHPInt).text();
                const totalCostWithoutHPInt = $("<div>").text(el.totalCostWithoutHPInt).text();
                const netBilledKwh = $("<div>").text(el.netBilledKwh).text();
                const netBillKwh = $("<div>").text(el.netBillKwh).text();
                const startDateFormatted = $("<div>").text(el.startDateFormatted).text();
                const startDateRaw = $("<div>").text(el.startDateRaw).text();
                const overTwoYearsBills = ($("<div>").text(el.overTwoYearsBills).text()).toLowerCase();
                const kwhToGrid = $("<div>").text(el.kwhToGrid).text();
                const account = $("<div>").text(el.account).text()

                const savingsTableRows = `
                  <tbody>
                    <tr>
                      <td>${startDateFormatted}</td>
                      <td>${fromKwh}</td>
                      ${toKwh == null || toKwh == "null" ? "<td>0</td>" : `<td>${kwhToGrid}</td>`}
                      ${netBilledKwh == null || netBilledKwh == "null" ? "<td>" + netBillKwh + "</td>" : "<td>" + Math.round(parseFloat(netBilledKwh)) + "</td>"}
                      <td class='decimal'>$${parseFloat(totalCostWithHPInt).toFixed(2)}</td>
                      <td class='decimal'>$${parseFloat(totalCostWithoutHPInt).toFixed(2)}</td>
                      ${totalCostWithoutHPInt - totalCostWithHPInt >= 0 ? `<td class='green decimal'>$${Math.abs(parseFloat(totalCostWithoutHPInt) - parseFloat(totalCostWithHPInt)).toFixed(2)} </td>` : `<td class='red decimal'>- $${Math.abs(parseFloat(totalCostWithHPInt) - parseFloat(totalCostWithoutHPInt)).toFixed(2)} </td>` }
                      ${overTwoYearsBills == 'true' ? `<td style='text-align: center'>N/A</td>` : `<td style='text-align: center'><a href='/bc-savings-detail/?account=${account}&date=${startDateRaw}'>View</a></td>`}
                      </tr>
                  </tbody>
                `

                $('#bill-table').append(savingsTableRows);
              })
              // $('#bill-table').append(testRow);
              $('#bill-table').tablesorter({
                theme: 'default',
                dateFormat: 'mmddyyyy', // set the default date format
                sortList: [
                  [0, 1],
                ],
                headers: {
                  0: {
                    sorter: 'shortDate',
                  }, //, dateFormat will parsed as the default above
                  1: {
                    sorter: 'shortDate',
                  }, // set day first format; set using class names
                  // 2: { sorter: "shortDate", dateFormat: "yyyymmdd" }  // set year first format; set using data attributes (jQuery data)
                },
              });
              // let the plugin know that we made a update 
              $('#bill-table').trigger('update');

              // add arrows
              $('#bill-table .decimal.green').prepend('<i class="fas fa-arrow-up"></i>');
              $('#bill-table .decimal.red').prepend('<i class="fas fa-arrow-down"></i>');

              $(".tablesorter-header").each(function () {
                $(this).attr({
                  'data-toggle': 'tooltip',
                  'data-placement': 'top'
                });
                $(this).children().attr({
                  title: $(this).attr('title'),
                  'data-toggle': 'tooltip',
                  'data-placement': 'top'
                });
              });
            });
          } else if (data == 'rider19') {
            $('.net-meter-off').hide();
            $('.net-meter-on').show();
            $('#report-my-savings-nm').attr('href', '/rrtpbillcompare/Servlet?type=report-my-savings-nmcg&account=' + $('#account').val());
            $.getJSON('/rrtpbillcompare/Servlet?type=bill-table-rider-19&account=' + $('#account').val(), function(data) {
              $('#bill-table thead').remove();
              $('#bill-table tbody tr').remove();
              $('#bill-table tbody').remove();
              $('#bill-table').trigger('destroy');
              $('#bill-table').append(data);
              $('#bill-table').tablesorter({
                theme: 'default',
                dateFormat: 'mmddyyyy', // set the default date format
                sortList: [
                  [0, 1] ],
                headers: {
                  0: {
                    sorter: 'shortDate',
                  }, //, dateFormat will parsed as the default above
                  1: {
                    sorter: 'shortDate',
                  }, // set day first format; set using class names
                  // 2: { sorter: "shortDate", dateFormat: "yyyymmdd" }  // set year first format; set using data attributes (jQuery data)
                },
              });
              // let the plugin know that we made a update 
              $('#bill-table').trigger('update');

              // add arrows
              $('#bill-table .decimal.green').prepend('<i class="fas fa-arrow-up"></i>');
              $('#bill-table .decimal.red').prepend('<i class="fas fa-arrow-down"></i>');

              $(".tablesorter-header").each(function () {
                $(this).attr({
                  'data-toggle': 'tooltip',
                  'data-placement': 'top'
                });
                $(this).children().attr({
                  title: $(this).attr('title'),
                  'data-toggle': 'tooltip',
                  'data-placement': 'top'
                });
              });
            });
          } else if (data == 'rider9') {
            $('.net-meter-off').hide();
            $('.net-meter-on').show();
            $('#report-my-savings-nm').attr('href', '/rrtpbillcompare/Servlet?type=report-my-savings-cg&account=' + $('#account').val());
            $.getJSON('/rrtpbillcompare/Servlet?type=bill-table-rider-9&account=' + $('#account').val(), function(data) {
              $('#bill-table thead').remove();
              $('#bill-table tbody tr').remove();
              $('#bill-table tbody').remove();
              $('#bill-table').trigger('destroy');
              $('#bill-table').append(data);
              $('#bill-table').tablesorter({
                theme: 'default',
                dateFormat: 'mmddyyyy', // set the default date format
                sortList: [
                  [0, 1] ],
                headers: {
                  0: {
                    sorter: 'shortDate',
                  }, //, dateFormat will parsed as the default above
                  1: {
                    sorter: 'shortDate',
                  }, // set day first format; set using class names
                  // 2: { sorter: "shortDate", dateFormat: "yyyymmdd" }  // set year first format; set using data attributes (jQuery data)
                },
              });
              // let the plugin know that we made a update 
              $('#bill-table').trigger('update');

              // add arrows
              $('#bill-table .decimal.green').prepend('<i class="fas fa-arrow-up"></i>');
              $('#bill-table .decimal.red').prepend('<i class="fas fa-arrow-down"></i>');
            });
          } else if (data == 'rider5') {
            $('.net-meter-off').hide();
            $('.net-meter-on').show();
            $('#report-my-savings-nm').attr('href', '/rrtpbillcompare/Servlet?type=report-my-savings-nm5&account=' + $('#account').val());
            $.getJSON('/rrtpbillcompare/Servlet?type=bill-table-rider-5&account=' + $('#account').val(), function(data) {
              $('#bill-table thead').remove();
              $('#bill-table tbody tr').remove();
              $('#bill-table tbody').remove();
              $('#bill-table').trigger('destroy');
              $('#bill-table').append(
                `<thead>
                  <tr>
                    <th id="start-date" title="This date indicates the end of your billing period.">
                      End of Billing Period
                    </th>
                    <th id="usage" title="kWh from the electric system.">
                      kWh From Grid
                    </th>
                    <th id="usage" title="kWh supplied to the electric system.">
                      kWh To Grid
                    </th>
                    <th id="total-cost-rrtp" title="This is the total cost of your electricity on Hourly Pricing.">
                      Total Cost With Hourly Pricing*
                    </th>
                    <th id="total-cost-std" title="This would be the total cost of your electricity if you were on ComEd standard fixed-price rate.">
                      Total Cost With ComEd Standard Rate**
                    </th>
                    <th id="savings-rrtp" title="This is the difference between the cost on Hourly Pricing vs. ComEd standard fixed price-rate. Savings are indicated by a positive number.">
                      Savings With Hourly Pricing
                    </th>
                    <th id="drill-down" title="Click the link below to see the billing details for each corresponding billing period.">
                      See Billing Details
                    </th>
                  </tr>
                </thead>`
              );
              data.forEach(el => {
                const fromKwh = $("<div>").text(el.fromKwh).text();
                const totalCostWithHPInt = $("<div>").text(el.totalCostWithHPInt).text();
                const totalCostWithoutHPInt = $("<div>").text(el.totalCostWithoutHPInt).text();
                const startDateFormatted = $("<div>").text(el.startDateFormatted).text();
                const startDateRaw = $("<div>").text(el.startDateRaw).text();
                const overTwoYearsBills = ($("<div>").text(el.overTwoYearsBills).text()).toLowerCase();
                const generatedKwh = $("<div>").text(el.generatedKwh).text();
                const account = $("<div>").text(el.account).text();
                const savingsTableRows = `
                  <tbody>
                    <tr>
                      <td>${startDateFormatted}</td>
                      <td>${fromKwh}</td>
                      <td>${generatedKwh}</td>
                      <td class='decimal'>$${parseFloat(totalCostWithHPInt).toFixed(2)}</td>
                      <td class='decimal'>$${parseFloat(totalCostWithoutHPInt).toFixed(2)}</td>
                       ${totalCostWithoutHPInt - totalCostWithHPInt >= 0 ? `<td class='green decimal'>$${Math.abs(parseFloat(totalCostWithoutHPInt) - parseFloat(totalCostWithHPInt)).toFixed(2)} </td>` : `<td class='red decimal'>- $${Math.abs(parseFloat(totalCostWithHPInt) - parseFloat(totalCostWithoutHPInt)).toFixed(2)} </td>` }
                      ${overTwoYearsBills == 'true' ? `<td style='text-align: center'>N/A</td>` : `<td style='text-align: center'><a href='/bc-savings-detail/?account=${account}&date=${startDateRaw}'>View</a></td>`}
                      </tr>
                  </tbody>
                `
                $('#bill-table').append(savingsTableRows);
              })
              
              $('#bill-table').tablesorter({
                theme: 'default',
                dateFormat: 'mmddyyyy', // set the default date format
                sortList: [
                  [0, 1] ],
                headers: {
                  0: {
                    sorter: 'shortDate',
                  }, //, dateFormat will parsed as the default above
                  1: {
                    sorter: 'shortDate',
                  }, // set day first format; set using class names
                  // 2: { sorter: "shortDate", dateFormat: "yyyymmdd" }  // set year first format; set using data attributes (jQuery data)
                },
              });
              // let the plugin know that we made a update 
              $('#bill-table').trigger('update');

              // add arrows
              $('#bill-table .decimal.green').prepend('<i class="fas fa-arrow-up"></i>');
              $('#bill-table .decimal.red').prepend('<i class="fas fa-arrow-down"></i>');

              $(".tablesorter-header").each(function () {
                $(this).attr({
                  'data-toggle': 'tooltip',
                  'data-placement': 'top'
                });
                $(this).children().attr({
                  title: $(this).attr('title'),
                  'data-toggle': 'tooltip',
                  'data-placement': 'top'
                });
              });
            });
          } else {
            $('.net-meter-off').show();
            $('.net-meter-on').hide();
            $.getJSON('/rrtpbillcompare/Servlet?type=bill-table&account=' + $('#account').val(), function(data) {
              $('#bill-table thead').remove();
              $('#bill-table tbody tr').remove();
              $('#bill-table tbody').remove();
              $('#bill-table').trigger('destroy');
              $('#bill-table').append(data);
              $('#bill-table').tablesorter({
                theme: 'default',
                dateFormat: 'mmddyyyy', // set the default date format
                sortList: [
                  [0, 1],
                ],
                headers: {
                  0: {
                    sorter: 'shortDate',
                  }, //, dateFormat will parsed as the default above
                  1: {
                    sorter: 'shortDate',
                  }, // set day first format; set using class names
                  // 2: { sorter: "shortDate", dateFormat: "yyyymmdd" }  // set year first format; set using data attributes (jQuery data)
                },
              });
              // let the plugin know that we made a update 
              $('#bill-table').trigger('update');

              // add arrows
              $('#bill-table .decimal.green').prepend('<i class="fas fa-arrow-up"></i>');
              $('#bill-table .decimal.red').prepend('<i class="fas fa-arrow-down"></i>');

              $(".tablesorter-header").each(function () {
                $(this).attr({
                  'data-toggle': 'tooltip',
                  'data-placement': 'top'
                });
                $(this).children().attr({
                  title: $(this).attr('title'),
                  'data-toggle': 'tooltip',
                  'data-placement': 'top'
                });
              });
            });
          }
        },
        cache: false,
        async: false,
      });
    }

    mhpa.loadAccountData();
  },
  finalize() {
    // JavaScript to be fired on the savings page, after the init JS
  },
};
